import React from "react";
import Logo from "../assets/images/logo.svg";

export default function Error() {
  return (
    <>
      <div className="LoginArea">
        <div className="LoginBox">
          <figure>
            <img src={Logo} />
          </figure>
          <h5>Page No Found</h5>
          <h6>404 | page not found</h6>
        </div>
      </div>
    </>
  );
}
